export type AppLanguage = "pt" | "en";

type DetectedLanguage = {
  language: AppLanguage;
  countryCode?: string;
};
const BRAZIL_TIMEZONES = new Set([
  "America/Araguaina",
  "America/Bahia",
  "America/Belem",
  "America/Boa_Vista",
  "America/Campo_Grande",
  "America/Cuiaba",
  "America/Fortaleza",
  "America/Maceio",
  "America/Manaus",
  "America/Noronha",
  "America/Porto_Velho",
  "America/Recife",
  "America/Rio_Branco",
  "America/Santarem",
  "America/Sao_Paulo",
]);

const parseLocaleRegion = (locale: string) => {
  const normalized = locale.replace("_", "-");
  const parts = normalized.split("-");
  return parts.length >= 2 ? parts[1]?.toUpperCase() : "";
};

const detectByBrowserSignals = (): AppLanguage => {
  const locales = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
  const hasPortugueseLocale = locales.some((locale) => locale.toLowerCase().startsWith("pt"));
  if (hasPortugueseLocale) return "pt";

  const hasBrazilLocale = locales.some((locale) => parseLocaleRegion(locale) === "BR");
  if (hasBrazilLocale) return "pt";

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timezone && BRAZIL_TIMEZONES.has(timezone)) return "pt";

  return "en";
};

export async function detectLanguageByRegion(): Promise<DetectedLanguage> {
  return { language: detectByBrowserSignals() };
}

export function languageToHtmlLang(language: AppLanguage) {
  return language === "pt" ? "pt-BR" : "en";
}

export function languageToLocale(language: AppLanguage) {
  return language === "pt" ? "pt-BR" : "en-US";
}

export function pickByLanguage<T>(language: AppLanguage, values: { pt: T; en: T }) {
  return language === "pt" ? values.pt : values.en;
}
